import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import React, { Component } from "react";
import * as googleMap from "react-google-maps";
import "react-toastify/dist/ReactToastify.min.css";
import CognitoIdentityServiceProvider from "aws-sdk/clients/cognitoidentityserviceprovider";
import NumberFormat from "react-number-format";
import Autocomplete from "react-google-autocomplete";

import {
  Button as Btn,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  Label,
  FormFeedback,
  FormText
} from "reactstrap";
import Chip from "@material-ui/core/Chip";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Switch from "@material-ui/core/Switch";

var self = null;
function Qualifications(prop) {
  const [open, setOpen] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [file, setFile] = React.useState(null);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose(id) {
    setOpen(false);
    if (id === 1) {
      prop.addQualification(title, file);
      setTitle("");
      setFile(null);
    }
  }
  return (
    <div>
      <Button
        style={{ float: "right" }}
        variant="outlined"
        color="primary"
        onClick={handleClickOpen}
      >
        +
      </Button>
      <Dialog
        open={open}
        maxWidth={"sm"}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ padding: 20 }}
      >
        <DialogTitle id="alert-dialog-title">
          {"Add Qualification Details"}
        </DialogTitle>
        <div className="row" style={{ margin: 0 }}>
          <div className="col">
            <Input
              id="skill"
              value={title}
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={e => setTitle(e.target.value)}
              placeholder="Qualification Title"
            />
          </div>
        </div>
        <div className="row" style={{ margin: 0, marginTop: 10 }}>
          <div className="col">
            <input type="file" onChange={e => setFile(e.target.files[0])} />
          </div>
        </div>
        <DialogActions>
          <Button onClick={() => handleClose(0)} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleClose(1)} color="primary" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
function Experiences(prop) {
  const [open, setOpen] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [city, setCity] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [currentlyWorking, setCurrentlyWorking] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose(id) {
    setOpen(false);
    if (id === 1) {
      prop.addExperience(
        title,
        company,
        city,
        country,
        description,
        endDate,
        startDate,
        currentlyWorking
      );
      setTitle("");
      setCompany("");
      setCity("");
      setDescription("");
      setEndDate("");
      setStartDate("");
      setCurrentlyWorking("");
      setCountry("");
    }
  }

  function _onFocus(e) {
    e.currentTarget.type = "date";
  }
  function _onBlur(e) {
    e.currentTarget.type = "text";
  }
  return (
    <div>
      <Button
        style={{ float: "right" }}
        variant="outlined"
        color="primary"
        onClick={handleClickOpen}
      >
        +
      </Button>
      <Dialog
        open={open}
        maxWidth={"sm"}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Add Employment Details"}
        </DialogTitle>
        <div className="row" style={{ margin: 0 }}>
          <div className="col">
            <Input
              placeholder="Company"
              value={company}
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={e => setCompany(e.target.value)}
            />
          </div>
        </div>
        <div className="row" style={{ margin: 0, marginTop: 10 }}>
          <div className="col">
            <Input
              placeholder="Title"
              value={title}
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={e => setTitle(e.target.value)}
            />
          </div>
        </div>
        <div className="row" style={{ margin: 0, marginTop: 10 }}>
          <div className="col">
            <Input
              placeholder="City"
              value={city}
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={e => setCity(e.target.value)}
            />
          </div>
          <div className="col">
            <Input
              placeholder="State"
              value={country}
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={e => setCountry(e.target.value)}
            />
          </div>
        </div>
        <div className="row" style={{ margin: 0, marginTop: 10 }}>
          <div className="col">
            <Input
              type="text"
              value={startDate}
              onFocus={e => _onFocus(e)}
              onBlur={e => _onBlur(e)}
              placeholder="Start Date"
              onChange={e => setStartDate(e.target.value)}
            />
          </div>
          <div className="col">
            <Input
              placeholder="End Date"
              onFocus={e => _onFocus(e)}
              onBlur={e => _onBlur(e)}
              type="text"
              value={endDate}
              onChange={e => setEndDate(e.target.value)}
            />
          </div>
        </div>

        <div className="row" style={{ margin: 0, marginTop: 10 }}>
          <div className="col">
            <input
              type="checkbox"
              checked={currentlyWorking}
              onChange={e => setCurrentlyWorking(e.target.checked)}
            />
            <span> I currently work here</span>
          </div>
        </div>
        <br />
        <div className="row" style={{ margin: 0, marginTop: 10 }}>
          <div className="col">
            <Input
              placeholder="Description"
              value={description}
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={e => setDescription(e.target.value)}
            />
          </div>
        </div>
        <DialogActions>
          <Button onClick={() => handleClose(0)} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleClose(1)} color="primary" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    self = this;

    this.state = {
      name: "",
      _name: {
        value: null,
        isValid: true,
        err: ""
      },
      email: "",
      _email: {
        value: null,
        isValid: true,
        err: ""
      },
      password: "",
      _password: {
        value: null,
        isValid: true,
        err: ""
      },
      cPassword: "",
      _cPassword: {
        value: null,
        isValid: true,
        err: ""
      },
      address: "",
      _address: {
        value: "",
        isValid: true,
        err: ""
      },
      city: "",
      _city: {
        value: "",
        isValid: true,
        err: ""
      },
      st: "",
      _st: {
        value: "",
        isValid: true,
        err: ""
      },
      phoneNum: null,
      _phoneNum: {
        value: null,
        isValid: true,
        err: ""
      },
      date: "",
      _date: {
        value: "",
        isValid: true,
        err: ""
      },
      skills: [],
      skill: "",
      qualifications: [],
      experiences: [],
      valid: true,
      phoneValidated: true,
      username: null,
      _username: {
        value: null,
        isValid: true,
        err: ""
      },
      emailValidate: true,
      emailFeadback: null,
      usernameValidate: true,
      usernameFeadback: null,
      iamMechanic: false,
      iamInspector: true
    };
  }
  onInspMechStats = e => {
    this.setState({ ...this.state, [e.target.value]: e.target.checked });
  };

  addQualification(title, file) {
    let qualifications = [...self.state.qualifications];
    qualifications.push({ title, file });
    self.setState({ qualifications });
  }
  addExperience(
    title,
    company,
    city,
    state,
    description,
    endDate,
    startDate,
    currentlyWorking
  ) {
    let experiences = [...self.state.experiences];
    var obj = {
      jobTitle: title,
      company,
      location: {
        city,
        state
      },
      description,
      currentlyWorking
    };
    if (startDate !== "") {
      obj.startDate = startDate;
    }
    if (endDate !== "") {
      obj.endDate = endDate;
    }
    experiences.push(obj);
    self.setState({ experiences });
  }
  handleSubmit = async event => {
    let {
      name,
      email,
      password,
      address,
      username,
      city,
      st,
      phoneNum,
      date,
      valid,
      phoneValidated,
      emailValidate,
      _name,
      _city,
      _st,
      _date,
      _password,
      _email,
      _cPassword,
      _phoneNum,
      _username,
      _address,
      cPassword
    } = this.state;
    event.preventDefault();

    if (!_name.isValid || _name.value === null || _name.value === undefined) {
      this.submitCheck("_name", _name.value);
      document.getElementById("_name").focus();
    }
    if (
      !_username.isValid ||
      _username.value === null ||
      _username.value === undefined
    ) {
      this.submitCheck("_username", _username.value);
      document.getElementById("_username").focus();
    }
    if (
      !emailValidate ||
      !_email.isValid ||
      _phoneNum.value === null ||
      _phoneNum.value === undefined
    ) {
      this.submitCheck("_email", _email.value);
      document.getElementById("_email").focus();
    }
    if (
      !_password.isValid ||
      _password.value === null ||
      _password.value === undefined
    ) {
      this.submitCheck("_password", _password.value);
      document.getElementById("_password").focus();
    }
    if (
      !_cPassword.isValid ||
      _cPassword.value === null ||
      _cPassword.value === undefined
    ) {
      this.submitCheck("_cPassword", _cPassword.value);
      document.getElementById("_cPassword").focus();
    }
    if (address === null || address === "" || address === undefined) {
      this.setState({
        _address: {
          isValid: false,
          err: "Kindly Select Your Location Properly"
        }
      });
      document.getElementById("address").focus();
    }
    if (!_city.isValid || city === null || city === undefined || city === "") {
      this.submitCheck("_city", city);
      document.getElementById("city").focus();
    }
    if (!_st.isValid || st === null || st === undefined || st === "") {
      this.submitCheck("_st", st);
      document.getElementById("st").focus();
    }
    if (
      !phoneValidated ||
      _phoneNum.value === "" ||
      _phoneNum.value === null ||
      _phoneNum.value === undefined
    ) {
      this.submitCheck("_phoneNum", _phoneNum.value);
      document.getElementById("_phoneNum").focus();
    }
    if (date === null || date === "") document.getElementById("_date").focus();
    if (!document.getElementById("cbRegister").checked)
      document.getElementById("cbRegister").focus();
    else {
      try {
        phoneNum = _phoneNum.value;
        name = _name.value;
        username =  _username.value.toLowerCase();
        password = _password.value;
        cPassword = _cPassword.value;
        this.setState({
          phoneNum: _phoneNum.value,
          name: _name.value,
          username: _username.value.toLowerCase(),
          password: _password.value,
          cPassword: _cPassword.value
        });
        phoneNum = phoneNum.replace("(", "");
        phoneNum = phoneNum.replace(")", "");
        phoneNum = phoneNum.replace("-", "");
        phoneNum = phoneNum.replace(" ", "");
        phoneNum = "+1" + phoneNum;
        const signUpResponse = await Auth.signUp({
          username,
          password,
          attributes: {
            phone_number: phoneNum
          }
        });
        localStorage.setItem("inspectorInfo", JSON.stringify(this.state));
        this.props.history.push({
          pathname: "/_Confirmation",
          state: { data: this.state, signUpResponse: signUpResponse.userSub }
        });
      } catch (err) {
        toast.error(err.message);
        if (err.code === "UsernameExistsException") {
          document.getElementById("username").focus();
          this.setState({
            usernameValidate: false,
            usernameFeadback: "Username already exist!"
          });
        }
      }
    }
  };

  passwordChange = (event, otherPassword) => {
    var valid = this.state.valid;
    if (event.target.value === otherPassword) {
      valid = true;
    } else {
      valid = false;
    }
    this.setState({
      [event.target.id]: event.target.value,
      valid
    });
  };

  _onPasswordChange = e => {
    e.currentTarget.type = "password";
    let { id, value } = e.target;
    this.setState({
      [id]: {
        value,
        isValid: true,
        err: ""
      }
    });
    if (id === "_password" && value.length < 6 && value.length > 0) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "Password Must be Atleast 6 Characters Long"
        }
      });
    }
    if (id === "_cPassword" && value !== this.state._password.value) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "Password Doesn't Match"
        }
      });
    }
  };

  onUsernameChange = event => {
    let val = event.target.value.toLowerCase();
    this.setState({
      [event.target.id]: val,
      usernameValidate: false,
      usernameFeadback: ""
    });
  };
  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
    if (
      event.target.id === "city" ||
      event.target.id === "state" ||
      event.target.id === "zipCode" ||
      event.target.id === "address"
    ) {
      const str = "_" + event.target.id;
      this.setState({
        [str]: {
          value: event.target.value,
          isValid: true,
          err: ""
        }
      });
    }
  };

  _onInputChange = event => {
    this.setState({
      [event.target.id]: {
        value: event.target.value,
        isValid: true,
        err: ""
      }
    });
  };

  _onPhoneChange = no => {
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (no.match(phoneno)) {
      this.setState({
        _phoneNum: {
          value: no,
          isValid: true,
          err: ""
        },
        phoneValidated: true
      });
    } else {
      this.setState({
        _phoneNum: {
          value: no,
          isValid: false,
          err: "Phone Num Not Valid"
        },
        phoneValidated: false
      });
    }
  };

  submitCheck = (id, value) => {
    let arr = [
      "_username",
      "_phoneNum",
      "_password",
      "_cPassword",
      "_email",
      "_city",
      "_st",
      "_zipCode",
      "_date"
    ];

    if (value === "" || value === null || value === undefined) {
      if (id === "_date") {
        this.setState({
          _date: {
            value,
            isValid: false,
            err: "Please Select One Date"
          }
        });
      } else
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
    } else if (value.length > 0) {
      if (id === "_username" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Atleast 6 Characters Are Reuired"
          }
        });
      } else if (!arr.includes(id) && value.length < 3)
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Atleast 3 Characters Are Reuired"
          }
        });
      else if (id === "_password" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Must be Atleast 6 Characters Long"
          }
        });
      } else if (id === "_cPassword" && value !== this.state._password.value) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Doesn't Match"
          }
        });
      } else if (!this.state.emailValidate && id === "_email") {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Email Entered is Not Valid"
          }
        });
      } else if (id === "_phoneNum") {
        this._onPhoneChange(value);
      }
    }
  };

  runtimeCheck = event => {
    let { id, value } = event.target;
    let arr = [
      "_username",
      "_phoneNum",
      "_password",
      "_cPassword",
      "_email",
      "_city",
      "_st",
      "_zipCode",
      "_date"
    ];

    if (value === "" || value === null || value === undefined) {
      if (id === "_date") {
        this.setState({
          _date: {
            value,
            isValid: false,
            err: "Please Select One Date"
          }
        });
      } else
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
    } else if (value.length > 0) {
      if (id === "_username" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Atleast 6 Characters Are Reuired"
          }
        });
      } else if (!arr.includes(id) && value.length < 3)
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Atleast 3 Characters Are Reuired"
          }
        });
      else if (id === "_password" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Must be Atleast 6 Characters Long"
          }
        });
      } else if (id === "_cPassword" && value !== this.state._password.value) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Doesn't Match"
          }
        });
      } else if (!this.state.emailValidate && id === "_email") {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Email Entered is Not Valid"
          }
        });
      } else if (id === "_phoneNum") {
        this._onPhoneChange(value);
      }
    }
  };

  onEmailChange = e => {
    let { value } = e.target;
    value = value.toLowerCase();
    this.setState({ email: value });
    if (/.+@.+\.[A-Za-z]+$/.test(value)) {
      Auth.signIn({ username: value, password: "123" })
        .then(res => {})
        .catch(err => {
          if (err.code !== "UserNotFoundException")
            this.setState({
              emailValidate: false,
              emailFeadback: "Email already exist!"
            });
          else this.setState({ emailValidate: true });
        });
    } else {
      this.setState({ emailValidate: false });
    }
  };

  _onEmailChange = e => {
    let { id, value } = e.target;
    value = value.toLowerCase();
    this.setState({ email: value });
    if (!/.+@.+\.[A-Za-z]+$/.test(value)) {
      this.setState({
        [id]: {
          value,
          isValid: true,
          err: ""
        },
        emailValidate: false
      });
    } else
      this.setState({
        [id]: {
          value,
          isValid: true,
          err: ""
        },
        emailValidate: true
      });
  };

  addSkill = data => {
    if (data.trim().length === 0) {
      toast.error("Please add skill name");
      return;
    }
    let skills = [...this.state.skills];
    if (skills.length !== 0 && skills.includes(data)) {
      toast.error("Skill name exists");
      return;
    }
    skills.push(data);
    this.setState({ skills, skill: "" });
  };
  deleteSkill = data => {
    var skills = [...this.state.skills];
    skills = skills.filter(obj => obj !== data);
    this.setState({ skills });
  };
  deleteQualification = title => {
    var qualifications = [...this.state.qualifications];
    qualifications = qualifications.filter(obj => obj.title !== title);
    this.setState({ qualifications });
  };
  deleteExperience = title => {
    var experiences = [...this.state.experiences];
    experiences = experiences.filter(obj => obj.jobTitle !== title);
    this.setState({ experiences });
  };
  _onFocus = e => {
    e.currentTarget.type = "date";
  };
  _onBlur = e => {
    e.currentTarget.type = "text";
  };
  validate = e => {
    e.preventDefault();
    let { name, value } = e.target;
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (value.match(phoneno)) {
      this.setState({ [name]: value, phoneValidated: true });
    } else {
      this.setState({ [name]: value, phoneValidated: false });
    }
  };
  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };
  handlePlaceSelect = e => {
    this.setState({ address: e.target.value });
    let addressObject = this.autocomplete.getPlace();

    if (addressObject) {
      let address = addressObject.address_components;
      address.forEach(item => {
        if (item.types[0] === "locality") {
          this.setState({ city: item.long_name });
        }
        if (item.types[0] === "administrative_area_level_1")
          this.setState({ st: item.long_name });
        if (item.types[0] === "postal_code")
          this.setState({ zipCode: item.long_name });
      });
    }
  };
  async componentDidMount() {
    this.autocomplete = await new window.google.maps.places.Autocomplete(
      document.getElementById("autocomplete"),
      {}
    );
  }
  render() {
    let { phoneValidated, emailValidate } = this.state;
    return (
      <div>
        <main ref="main" App>
          <ToastContainer />
          <section className="section section-shaped section-lg">
            <Container className="pt-lg-sm pt-2">
              <Row className="justify-content-center">
                <Col lg="7">
                  <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-white pb-2 pt-3">
                      <div className=" pb-2">
                        <span style={{ fontSize: "30px" }}>
                          {" "}
                          Register As Inspector
                        </span>
                      </div>
                      <div className="pb-1">
                        <p style={{ fontSize: "20px" }}>
                          {" "}
                          Create a new account{" "}
                        </p>
                      </div>
                    </CardHeader>

                    <CardBody
                      style={{ backgroundColor: "White" }}
                      className="px-5 "
                    >
                      <Form autoComplete="new-password" role="form">
                        <input
                          autoComplete="off"
                          name="hidden"
                          type="text"
                          style={{ display: "none" }}
                        />

                        <div>
                          <Row form>
                            <Col md={12}>
                              <FormGroup>
                                {" "}
                                <Label for="name">Full Name</Label>
                                <InputGroup className="input-group-alternative mb-3">
                                  <Input
                                    id="_name"
                                    onChange={this._onInputChange}
                                    placeholder="Full Name"
                                    type="text"
                                    style={{
                                      borderColor: !this.state._name.isValid
                                        ? "red"
                                        : ""
                                    }}
                                    value={this.state._name.value}
                                    onBlur={e => this.runtimeCheck(e)}
                                    // autoComplete={
                                    //   this.state.name_name.value === ""
                                    //     ? ""
                                    //     : this.state._name.value
                                    // }
                                    required
                                  />
                                  {!this.state._name.isValid && (
                                    <text
                                      style={{
                                        color: "red",
                                        fontSize: 12,
                                        marginLeft: 10
                                      }}
                                    >
                                      {" "}
                                      {this.state._name.err}
                                    </text>
                                  )}
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row form>
                            <Col md={12}>
                              <FormGroup>
                                <Label for="name">User Name</Label>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="_username"
                                    style={{
                                      borderColor: !this.state._username.isValid
                                        ? "red"
                                        : ""
                                    }}
                                    onChange={this._onInputChange}
                                    onBlur={e => this.runtimeCheck(e)}
                                    placeholder="User Name (Used to login the system)"
                                    type="text"
                                    value={this.state._username.value}
                                  />
                                  {!this.state._username.isValid && (
                                    <text
                                      style={{
                                        color: "red",
                                        fontSize: 12,
                                        marginLeft: 10
                                      }}
                                    >
                                      {" "}
                                      {this.state._username.err}
                                    </text>
                                  )}
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                {" "}
                                <Label for="name">Password</Label>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    value={this.state._password.value}
                                    id="_password"
                                    style={{
                                      borderColor: !this.state._password.isValid
                                        ? "red"
                                        : ""
                                    }}
                                    onChange={e => this._onPasswordChange(e)}
                                    onBlur={e => this.runtimeCheck(e)}
                                    placeholder="Password"
                                    type="password"
                                    // onFocus={e =>
                                    //   (e.currentTarget.type = "password")
                                    // }
                                    required
                                  />
                                </InputGroup>
                                {!this.state._password.isValid && (
                                  <text
                                    style={{
                                      color: "red",
                                      fontSize: 12,
                                      marginLeft: 10
                                    }}
                                  >
                                    {" "}
                                    {this.state._password.err}
                                  </text>
                                )}
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="name">Confirm Password</Label>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    style={{
                                      borderColor: !this.state._cPassword
                                        .isValid
                                        ? "red"
                                        : ""
                                    }}
                                    value={this.state._cPassword.value}
                                    id="_cPassword"
                                    onChange={e => this._onPasswordChange(e)}
                                    onBlur={e => this.runtimeCheck(e)}
                                    placeholder="Confirm Password"
                                    type="password"
                                    // onFocus={e =>
                                    //   (e.currentTarget.type = "password")
                                    // }
                                    required
                                  />
                                  {/* <FormFeedback>
                                    Password not same! Please Check.
                                  </FormFeedback> */}
                                </InputGroup>
                                {!this.state._cPassword.isValid && (
                                  <text
                                    style={{
                                      color: "red",
                                      fontSize: 12,
                                      marginLeft: 10
                                    }}
                                  >
                                    {" "}
                                    {this.state._cPassword.err}
                                  </text>
                                )}
                              </FormGroup>
                            </Col>
                          </Row>

                          <FormGroup>
                            <Label for="name">Address</Label>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Autocomplete
                                style={{
                                  padding: 6,
                                  width: "94%",
                                  borderLeft: 0,
                                  borderColor: this.state._address.isValid
                                    ? ""
                                    : "red"
                                  // borderTop: 'thin .5px'
                                  // marginLeft: "10px",
                                  // marginTop: "15px"
                                }}
                                id="address"
                                value={this.state.address}
                                onChange={this.onInputChange}
                                type="text"
                                placeholder="Street address"
                                onPlaceSelected={place => {
                                  let stateObj = {};
                                  var componentForm = {
                                    street_number: "short_name",
                                    route: "long_name",
                                    locality: "long_name",
                                    administrative_area_level_1: "short_name",
                                    country: "long_name",
                                    postal_code: "short_name"
                                  };
                                  let address = place.address_components;
                                  address !== undefined &&
                                    address.forEach(item => {
                                      if (componentForm[item.types[0]]) {
                                        if (item.types[0] === "locality")
                                          stateObj.city = item.long_name;

                                        if (
                                          item.types[0] ===
                                          "administrative_area_level_1"
                                        )
                                          stateObj.st = item.long_name;
                                        if (item.types[0] === "postal_code")
                                          stateObj.zipCode = item.long_name;
                                      }
                                    });
                                  stateObj.address = place.formatted_address;
                                  stateObj.lat = place.geometry.location.lat();
                                  stateObj.lng = place.geometry.location.lng();
                                  this.setState(stateObj);
                                  this.setState({
                                    _city: {
                                      isValid: true,
                                      err: ""
                                    },
                                    _st: {
                                      isValid: true,
                                      err: ""
                                    },
                                    _zipCode: {
                                      isValid: true,
                                      err: ""
                                    },
                                    _address: {
                                      isValid: true,
                                      err: ""
                                    }
                                  });
                                }}
                                types={["address"]}
                                componentRestrictions={{ country: "us" }}
                                fields={[
                                  "geometry",
                                  "formatted_address",
                                  "address_components"
                                ]}
                              />
                              <div
                                style={{
                                  fontSize: "x-small",
                                  marginLeft: "10px",
                                  color: !this.state._address.isValid
                                    ? "red"
                                    : ""
                                }}
                              >
                                Please use Google auto suggest to exactly show
                                your location on our app maps.
                              </div>
                              {/* <Input
                                id="autocomplete"
                                onChange={e => this.handlePlaceSelect(e)}
                                onSelect={e => this.handlePlaceSelect(e)}
                                placeholder="Address"
                                type="text"
                                value={this.state.address}
                                autoComplete={
                                  this.state.address === ""
                                    ? ""
                                    : this.state.address
                                }
                                onKeyDown={e => {
                                  if (e.keyCode === 13)
                                    this.handlePlaceSelect(e);
                                }}
                                onBlur={e => this.handlePlaceSelect(e)}
                              /> */}
                            </InputGroup>
                          </FormGroup>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="name">City</Label>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="city"
                                    style={{
                                      borderColor: !this.state._city.isValid
                                        ? "red"
                                        : ""
                                    }}
                                    onChange={this.onInputChange}
                                    placeholder="City"
                                    type="text"
                                    value={this.state.city}
                                    onBlur={() => {
                                      if (
                                        this.state.city === null ||
                                        this.state.city === undefined ||
                                        this.state.city === ""
                                      ) {
                                        this.setState({
                                          _city: {
                                            value: this.state.city,
                                            isValid: false,
                                            err: "Please Specify Your City"
                                          }
                                        });
                                      } else {
                                        this.setState({
                                          _city: {
                                            value: this.state.city,
                                            isValid: true,
                                            err: ""
                                          }
                                        });
                                      }
                                    }}
                                    autoComplete={
                                      this.state.city === ""
                                        ? ""
                                        : this.state.city
                                    }
                                  />
                                </InputGroup>
                                {!this.state._city.isValid && (
                                  <text
                                    style={{
                                      color: "red",
                                      fontSize: 12,
                                      marginLeft: 10
                                    }}
                                  >
                                    {" "}
                                    {this.state._city.err}
                                  </text>
                                )}
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="name">State</Label>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="st"
                                    onChange={this.onInputChange}
                                    style={{
                                      borderColor: !this.state._st.isValid
                                        ? "red"
                                        : ""
                                    }}
                                    onBlur={() => {
                                      if (
                                        this.state.st === null ||
                                        this.state.st === undefined ||
                                        this.state.st === ""
                                      ) {
                                        this.setState({
                                          _st: {
                                            value: this.state.st,
                                            isValid: false,
                                            err: "Please Specify Your State"
                                          }
                                        });
                                      } else {
                                        this.setState({
                                          _st: {
                                            value: this.state.st,
                                            isValid: true,
                                            err: ""
                                          }
                                        });
                                      }
                                    }}
                                    placeholder="State"
                                    type="text"
                                    value={this.state.st}
                                    autoComplete={
                                      this.state.st === "" ? "" : this.state.st
                                    }
                                  />
                                </InputGroup>
                                {!this.state._st.isValid && (
                                  <text
                                    style={{
                                      color: "red",
                                      fontSize: 12,
                                      marginLeft: 10
                                    }}
                                  >
                                    {" "}
                                    {this.state._st.err}
                                  </text>
                                )}
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row form>
                            <Col md={12}>
                              <FormGroup>
                                <Label for="name">Phone No</Label>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <NumberFormat
                                    className="form-control"
                                    // invalid={
                                    //   phoneValidated === true ? false : true
                                    // }
                                    id="_phoneNum"
                                    style={{
                                      borderColor: !this.state._phoneNum.isValid
                                        ? "red"
                                        : ""
                                    }}
                                    onChange={e => this._onInputChange(e)}
                                    onBlur={e => this.runtimeCheck(e)}
                                    placeholder="Phone No (541) 754-3010"
                                    type="tel"
                                    value={this.state._phoneNum.value}
                                    name="phoneNum"
                                    format="(###) ###-####"
                                    autoComplete={
                                      this.state._phoneNum.value === ""
                                        ? ""
                                        : this.state._phoneNum.value
                                    }
                                  />
                                  {!this.state._phoneNum.isValid && (
                                    <text
                                      style={{
                                        color: "red",
                                        fontSize: 12,
                                        marginLeft: 10
                                      }}
                                    >
                                      {" "}
                                      {this.state._phoneNum.err}
                                    </text>
                                  )}
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="name">Email</Label>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="_email"
                                    style={{
                                      borderColor: !this.state._email.isValid
                                        ? "red"
                                        : ""
                                    }}
                                    onChange={this._onEmailChange}
                                    placeholder="Email"
                                    type="text"
                                    autoComplete={
                                      this.state._email.value === ""
                                        ? ""
                                        : this.state._email.value
                                    }
                                    required
                                    onFocus={e =>
                                      (e.currentTarget.type = "email")
                                    }
                                    onBlur={e => this.runtimeCheck(e)}
                                    value={this.state._email.value}
                                  />
                                  {/* <FormFeedback>
                                    {this.state.emailFeadback}
                                  </FormFeedback> */}
                                </InputGroup>
                                {!this.state._email.isValid && (
                                  <text
                                    style={{
                                      color: "red",
                                      fontSize: 12,
                                      marginLeft: 10
                                    }}
                                  >
                                    {" "}
                                    {this.state._email.err}
                                  </text>
                                )}
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="name">Inspecting Since</Label>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="_date"
                                    style={{
                                      borderColor: !this.state._date.isValid
                                        ? "red"
                                        : ""
                                    }}
                                    type="date"
                                    // onFocus={e => this._onFocus(e)}
                                    onBlur={e => this.runtimeCheck(e)}
                                    placeholder="Inspecting Since"
                                    onChange={e => this._onInputChange(e)}
                                  />
                                </InputGroup>
                                {!this.state._date.isValid && (
                                  <text
                                    style={{
                                      color: "red",
                                      fontSize: 12,
                                      marginLeft: 10
                                    }}
                                  >
                                    {" "}
                                    {this.state._date.err}
                                  </text>
                                )}
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                        <Card style={{ marginTop: "20px" }}>
                          <CardHeader>
                            <div className="row">
                              <p className="col" style={{ paddingTop: "10px" }}>
                                Employment History
                              </p>
                              <div className="col">
                                <Experiences
                                  addExperience={this.addExperience}
                                />
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody>
                            {this.state.experiences.length !== 0 &&
                              this.state.experiences.map((item, key) => {
                                return (
                                  <div>
                                    <h5 style={{ color: "black" }}>
                                      {item.jobTitle}
                                    </h5>
                                    <div className="row">
                                      <div className="col-10">
                                        <p>Company:{" " + item.company}</p>
                                      </div>
                                      <div className="col-2">
                                        <input
                                          type="button"
                                          onClick={() =>
                                            this.deleteExperience(item.jobTitle)
                                          }
                                          value="X"
                                        />
                                      </div>
                                    </div>
                                    <hr />
                                  </div>
                                );
                              }, this)}
                          </CardBody>
                        </Card>
                        <Card style={{ marginTop: "20px" }}>
                          <CardHeader>
                            <div className="row">
                              <p className="col" style={{ paddingTop: "10px" }}>
                                Qualifications
                              </p>
                              <div className="col">
                                <Qualifications
                                  addQualification={this.addQualification}
                                />
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody>
                            {this.state.qualifications.length !== 0 &&
                              this.state.qualifications.map((item, key) => {
                                return (
                                  <div>
                                    <div className="row">
                                      <div className="col-4">
                                        <h5>{item.title}</h5>
                                      </div>
                                      <div className="col-6">
                                        <p>
                                          {item.file !== null
                                            ? "File Uploaded"
                                            : "No File Uploaded"}
                                        </p>
                                      </div>
                                      <div className="col-2">
                                        <input
                                          type="button"
                                          onClick={() =>
                                            this.deleteQualification(item.title)
                                          }
                                          value="X"
                                        />
                                      </div>
                                    </div>
                                    <hr />
                                  </div>
                                );
                              }, this)}
                          </CardBody>
                        </Card>
                        <Card style={{ marginTop: "20px" }}>
                          <CardHeader>Skills</CardHeader>
                          <CardBody>
                            {this.state.skills.length !== 0 &&
                              this.state.skills.map((item, key) => {
                                return (
                                  <Chip
                                    key={key}
                                    label={item}
                                    onDelete={() => this.deleteSkill(item)}
                                  />
                                );
                              }, this)}
                            <div className="row" style={{ marginTop: 7 }}>
                              <div className="col" style={{ paddingRight: 0 }}>
                                <Input
                                  id="skill"
                                  placeholder="Skill Name"
                                  value={this.state.skill}
                                  onChange={this.onInputChange}
                                  inputProps={{
                                    "aria-label": "Description"
                                  }}
                                />
                              </div>
                              <div className="col" style={{ paddingLeft: 0 }}>
                                <Btn
                                  variant="outlined"
                                  color="primary"
                                  onClick={() =>
                                    this.addSkill(this.state.skill)
                                  }
                                >
                                  +
                                </Btn>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                        <Row
                          lg="12"
                          style={{ paddingTop: 20, display: "none" }}
                          className="px-3 "
                        >
                          <Col>
                            Register me as Inspector
                            <span style={{ float: "right" }}>
                              <Switch
                                checked={this.state.iamInspector}
                                onChange={this.onInspMechStats}
                                value="iamInspector"
                                inputProps={{
                                  "aria-label": "secondary checkbox"
                                }}
                              />
                            </span>
                          </Col>
                        </Row>
                        <Row
                          lg="12"
                          style={{ display: "none" }}
                          className="px-3 "
                        >
                          <Col>
                            Register me as Mechanic
                            <span style={{ float: "right" }}>
                              <Switch
                                checked={this.state.iamMechanic}
                                onChange={this.onInspMechStats}
                                value="iamMechanic"
                                inputProps={{
                                  "aria-label": "secondary checkbox"
                                }}
                              />
                            </span>
                          </Col>
                        </Row>
                        <Row className="my-4">
                          <Col xs="12">
                            <div className="custom-control custom-control-alternative custom-checkbox">
                              <input
                                className="custom-control-input"
                                id="cbRegister"
                                type="checkbox"
                                required
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="cbRegister"
                              ></label>

                              <span>
                                I agree with the{" "}
                                <a
                                  href="#pablo"
                                  onClick={e => e.preventDefault()}
                                >
                                  Privacy Policy
                                </a>
                              </span>
                            </div>
                          </Col>
                        </Row>
                        <div className="text-center">
                          <Row lg="12" className="px-3 ">
                            <Col>
                              <Btn
                                className=" btn-lg mt-2"
                                color="primary"
                                type="button"
                                onClick={this.handleSubmit}
                              >
                                Create account
                              </Btn>
                            </Col>
                          </Row>
                        </div>

                        <div className=" row  mb-2 ml-3">
                          {" "}
                          <span className="col-sm-4 col-md-4 col-xs-4">
                            <Btn
                              className="bg-transparent text-info"
                              to="/Customer-Reg"
                              tag={Link}
                              color=""
                            >
                              {" "}
                              Register as Customer
                            </Btn>
                          </span>
                          <span className="'col-sm-2 col-md-2 col-xs-2"></span>
                          <span className="col-sm-4 col-md-4 col-xs-4">
                            <Btn
                              className="bg-transparent text-info"
                              to="/login-page"
                              tag={Link}
                              color=""
                            >
                              {" "}
                              Already have an account?Sign in
                            </Btn>
                          </span>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    );
  }
}

export default RegistrationForm;



// WEBPACK FOOTER //
// ./src/pages/RegistrationPage.js